
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hiredly-x",
      function () {
        return require("private-next-pages/hiredly-x/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hiredly-x"])
      });
    }
  